export default __webpack_public_path__ + "static/media/reject.1af37c96.svg";